<!-- The span carries the tooltip: a disabled button sends no mouse events. -->
<span
    class="inline-flex"
    [class.w-full]="fluid()"
    [pTooltip]="disabled() ? disabledReason() : ''"
    tooltipPosition="top"
>
    <button
        pButton
        [type]="type()"
        [severity]="severity()"
        [size]="size()"
        [outlined]="outlined()"
        [text]="text()"
        [fluid]="fluid()"
        [iconOnly]="!label()"
        [disabled]="disabled() || loading()"
        [attr.aria-label]="ariaLabel()"
        [attr.data-testid]="testId()"
        (click)="clicked.emit($event)"
    >
        @if (loading()) {
            <i class="pi pi-spinner pi-spin" aria-hidden="true"></i>
        } @else if (icon() && iconPos() === 'left') {
            <i [class]="icon()" aria-hidden="true"></i>
        }
        @if (label()) {
            {{ label() }}
        }
        @if (!loading() && icon() && iconPos() === 'right') {
            <i [class]="icon()" aria-hidden="true"></i>
        }
    </button>
</span>
